import axionIns from "../axios";

const getActivationAnalyticsFirebaseEvents = (params) => {
  return axionIns.get("admin/activation-analytics/firebase-events", { params }).then((response) => { return response.data });
};

const activationAnalyticsService = {
  getActivationAnalyticsFirebaseEvents,
};

export default activationAnalyticsService;
